import { Box } from "@mui/material";
import { useParams, useSearchParams } from "react-router-dom";
import { DocumentsView } from "src/components/Documents/DocumentsView";
import { DocumentTrashView } from "src/components/Documents/DocumentTrashView";
import { FramesView } from "src/components/Frames/FramesView";

/**
 * Shell of the documents page: picks among active documents, frame templates,
 * and recoverable document Trash based on the `view` search param.
 * Each view renders its own header; the toggle between them lives in
 * `DocumentsPageViewToggle`.
 */
export const DocumentsPage = () => {
  const { orgId = "" } = useParams<{ orgId: string }>();
  const [searchParams] = useSearchParams();
  const folderId = searchParams.get("folderId");
  const isFramesView = searchParams.get("view") === "frames";
  const isTrashView = searchParams.get("view") === "trash";

  return (
    <Box
      data-folder-id={folderId ?? undefined}
      data-testid="documents-page"
      sx={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
        p: 0,
      }}
    >
      {isFramesView ? (
        <FramesView orgId={orgId} />
      ) : isTrashView ? (
        <DocumentTrashView orgId={orgId} />
      ) : (
        <DocumentsView orgId={orgId} />
      )}
    </Box>
  );
};

export default DocumentsPage;
